import { Box, Container, Grid, Stack, Typography } from '@mui/material'
import mobile from "../../../assets/images/mobile.webp"
import googlePlay from "../../../assets/images/app-store-button.svg"
import appStore from "../../../assets/images/google-play-button.svg"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
export const DounloadApp = () => {
    const { t } = useTranslation("home")
    return (

        <Box sx={{ backgroundColor: "text.main", py: 4 }}>
            <Container>
                <Grid container spacing={2} >
                    <Grid item xs={12} md={8} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <Box sx={{}}>
                            <Typography variant="h5" sx={{ color: "primary.main", letterSpacing: "5px", fontWeight: "bold" }}>
                                {
                                    t("DounloadApp.title")
                                }
                            </Typography>
                            <Typography variant="h3" sx={{
                                color: "secondary.main", fontWeight: "bolder", fontSize: ["30px", "40px"],
                                "::after": {
                                    "content": `"${t('DounloadApp.title2.2')}"`,
                                    "color": "primary.main",
                                    "paddingLeft": "15px",
                                    "fontFamily": "Poppins-Bold"
                                },
                            }}>
                                {t("DounloadApp.title2.1")}

                            </Typography>
                            <Typography variant="body1" sx={{ color: "secondary.main", mt: 1 }}>
                                {t("DounloadApp.description.1")}
                            </Typography>

                            <Stack spacing={1} direction="row" sx={{ maxWidth: "250px", pt: 2 }}>
                                <Link to="/">
                                    <img src={googlePlay} alt="mobile app" loading='lazy' style={{ width: "120px", height: "45px", objectFit: "contain" }} />
                                </Link>
                                <Link to="/">
                                    <img src={appStore} alt="app" loading='lazy' style={{ width: "120px", height: "45px", objectFit: "contain" }} />
                                </Link>
                            </Stack>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <img src={mobile} alt="app" loading='lazy' style={{ width: "100%", height: "100%", objectFit: "contain" }} />

                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
}
